import type { ReactNode } from "react";
import { Typography, useMediaQuery } from "@mui/material";
import type { SxProps, TypographyProps } from "@mui/material";

interface BarcodeTypographyProps extends Omit<TypographyProps, "sx"> {
  variant: "barcode1" | "barcode2";
  matricule: string | undefined;
  sx?: SxProps;
}

function BarcodeTypography({
  variant,
  matricule,
  sx,
  ...props
}: Readonly<BarcodeTypographyProps>): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  if (matricule == null) {
    return <Typography>Pas de matricule</Typography>;
  }

  return (
    <Typography
      sx={{ ...sx, fontSize: isSmallScreen ? "2.5rem" : "3rem" }}
      variant={variant}
      {...props}>
      *0000{matricule}CO*
    </Typography>
  );
}

export default BarcodeTypography;
